import React from 'react';
import { useTranslationContext } from '../../context/TranslationContext';
export var DefaultSuggestionListHeader = function DefaultSuggestionListHeader(_a) {
  var value = _a.value;
  var t = useTranslationContext().t;

  if (value[0] === '/') {
    return React.createElement(React.Fragment, null, t('Commands matching'), " ", React.createElement("strong", null, value.replace('/', '')));
  }

  if (value[0] === ':') {
    return React.createElement(React.Fragment, null, t('Emoji matching'), " ", React.createElement("strong", null, value.replace(':', '')));
  }

  if (value[0] === '@') {
    return React.createElement(React.Fragment, null, t('People matching'), " ", React.createElement("strong", null, value.replace('@', '')));
  }

  return null;
};